import { Component, OnInit, Input } from '@angular/core';
import { Oferent } from 'app/model/oferent';
import { OfferService } from 'app/services/offer.service';
import { AuthService } from 'app/services/auth.service';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxCarousel } from 'ngx-carousel';
import { MontagePriceService } from 'app/services/montage-price.service';
import { CenaMontazu } from 'app/model/cena';
import { isHK } from 'app/app.component';

@Component({
  selector: 'app-offers-editor',
  templateUrl: './offers-editor.component.html',
  styleUrls: ['./offers-editor.component.css']
})
export class OffersEditorComponent implements OnInit {
  @Input() model: Oferent;
  public carouselInstallationPrices: NgxCarousel;
  empty_price = new CenaMontazu();
  iter4 = [0, 1, 2, 3];

  wojewodztwaNames = ['lubelskie', 'mazowieckie', 'podkarpackie', 'świętokrzyskie'];

  constructor(
    private offerService: OfferService,
    private montagePriceService: MontagePriceService,
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private location: Location) {
  }

  ngOnInit() {
    this.getModel();
    this.carouselInstallationPrices = {
      grid: { xs: 1, sm: 1, md: 1, lg: 1, all: 0 },
      slide: 1,
      speed: 400,
      interval: 4000,
      point: {
        visible: true
      },
      load: 2,
      touch: true,
      loop: false,
      custom: 'banner'
    }
  }

  getIsHK(): boolean {
    return isHK;
  }

  getModel(): void {
    const id = this.route.snapshot.paramMap.get('id');
    if (id) {
      this.offerService.getOffer(id)
        .subscribe(oferent => this.model = oferent);
    } else {
      this.model = new Oferent();
      this.model.nazwa = '';
      this.model.adres = '';
      this.model.email = '';
      this.model.tel = '';
      this.model.www = '';
      this.model.info = '';
    }
  }

  save() {
    if (this.model.nazwa) {
      this.offerService.save(this.model);
      // this.model = new Oferent();
      // this.router.navigate(['/offers']);
    }
  }

  newOffer(): void {
    this.model = new Oferent();
  }

  getPrices() {
    return this.montagePriceService.getPrices(this.model.id);
  }

  isSuperUser() {
    return this.authService.isSuperUser();
  }

  isAdmin(): boolean {
    return this.authService.isAdmin();
  }

  cancel() {
    this.offerService.reloadFromDb();
    this.model = new Oferent();
    this.router.navigate(['/offers']);
  }

  newPrice(offerId: string, priceObj: CenaMontazu) {
    const pr = new CenaMontazu();
    if (priceObj) {
      pr.cena = priceObj.cena;
      pr.dostawca_id = offerId;
      pr.moc_do = priceObj.moc_do;
      pr.moc_od = priceObj.moc_od;
    }

    this.empty_price = new CenaMontazu();
    this.montagePriceService.save(pr);
  }


  savePrice(offerId: string, priceObj: CenaMontazu) {
    priceObj.dostawca_id = offerId;
    this.montagePriceService.save(priceObj);
  }


  deletePrice(price_id: string) {
    this.montagePriceService.delete(price_id);
  }

}



// WEBPACK FOOTER //
// /Users/michaldudziak/Desktop/Projekty/Projekt-Sunroof/Sunroof/src/app/offers-editor/offers-editor.component.ts